/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountingCategoryModel {
    /** @format int32 */
    accountingCategoryId?: number;
    accountingCategory?: string | null;
    /** @format int32 */
    createdById?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    lastUpdate?: string;
}

export interface AccountingCategoryPostModel {
    /** @format int32 */
    accountingCategoryId?: number;
    accountingCategory?: string | null;
}

export interface AccountingCodeModel {
    /** @format int32 */
    accountingCodeId?: number;
    accountingCode?: string | null;
    accountingCodeDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
    /** @format int32 */
    createdById?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    lastUpdate?: string;
}

export interface AccountingCodePostModel {
    /** @format int32 */
    accountingCodeId?: number;
    accountingCode?: string | null;
    accountingCodeDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export enum ActiveEnums {
    NotActive = "NotActive",
    ActiveOnly = "ActiveOnly",
    All = "All",
}

export interface AddEditPhasePostModel {
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    phaseId?: number;
    phaseCode?: string | null;
    phaseDescription?: string | null;
}

export interface AddEditRosterDetailPostModel {
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    rosterDetailId?: number;
    /** @format date-time */
    effectiveDate?: string;
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    timeReimbursable?: boolean;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    /** @format double */
    incentiveRate?: number;
}

export interface AddressModel {
    /** @format int32 */
    addressId?: number;
    address1?: string | null;
    address2?: string | null;
    /** @format int32 */
    cityStateId?: number;
    city?: string | null;
    /** @format int32 */
    stateCodeId?: number;
    state?: string | null;
    postalCode?: string | null;
}

export interface AdjustmentsTotalModel {
    /** @format int32 */
    quantityTotal?: number;
    /** @format double */
    amountTotal?: number;
    amountTotalDisplay?: string | null;
}

export interface AssignmentBudgetChartModel {
    staff_name?: string | null;
    is_active?: boolean;
    /** @format int32 */
    phase_sort_order?: number;
    phase_description?: string | null;
    /** @format int32 */
    category_sort_order?: number;
    category_description?: string | null;
    /** @format double */
    total_budget?: number;
    /** @format double */
    budget_used?: number;
}

export interface AssignmentDetailPostModel {
    /** @format int32 */
    id?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format date-time */
    effDate?: string;
    /** @format int32 */
    packageId?: number;
    billableTime?: boolean;
    billableTravel?: boolean;
    billableIndvExp?: boolean;
    billableOffExp?: boolean;
    invVisTime?: boolean;
    invVisTravel?: boolean;
    invVisIndvExp?: boolean;
    invVisOffExp?: boolean;
    /** @format double */
    costRt?: number;
    /** @format double */
    billingRt?: number;
    /** @format double */
    internalRt?: number;
}

export interface AssignmentDetailsModel {
    active?: boolean;
    /** @format int32 */
    assignDetailId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    workPackageId?: number;
    workPackageCode?: string | null;
    /** @format date-time */
    effectiveDate?: string;
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format double */
    defaultCostRate?: number;
    /** @format double */
    defaultBillingRate?: number;
    /** @format double */
    defaultInternalRate?: number;
    effectiveDateDisplay?: string | null;
    billableTimeDisplay?: string | null;
    billableTravelExpenseDisplay?: string | null;
    billableOtherIndividualExpenseDisplay?: string | null;
    billableOfficeExpenseDisplay?: string | null;
    invoiceVisibleTimeDisplay?: string | null;
    invoiceVisibleTravelExpenseDisplay?: string | null;
    invoiceVisibleOtherIndividualExpenseDisplay?: string | null;
    invoiceVisibleOfficeExpenseDisplay?: string | null;
    defaultCostRateDisplay?: string | null;
    defaultBillingRateDisplay?: string | null;
    defaultInternalRateDisplay?: string | null;
}

export interface AssignmentExpenseDetailPostModel {
    /** @format int32 */
    id?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format date-time */
    effDate?: string;
    /** @format int32 */
    subCatalogId?: number;
    reimbursable?: boolean;
    /** @format double */
    costRt?: number;
    /** @format double */
    billingRt?: number;
    /** @format double */
    internalRt?: number;
    /** @format double */
    markup?: number;
}

export interface AssignmentMiniModel {
    /** @format int32 */
    assignmentId?: number;
    displayName?: string | null;
}

export interface AssignmentModel {
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    clientId?: number;
    clientName?: string | null;
    clientNameShort?: string | null;
    /** @format int32 */
    extensionId?: number;
    extensionCode?: string | null;
    extensionDescription?: string | null;
    assignNum?: string | null;
    assignDesc?: string | null;
    displayName?: string | null;
    /** @format int32 */
    sortBy?: number;
    isActive?: boolean;
    isActiveDisplay?: string | null;
    /** @format date-time */
    startDate?: string;
    startDateDisplay?: string | null;
    /** @format date-time */
    endDate?: string;
    endDateDisplay?: string | null;
    /** @format int32 */
    utilizationCodeId?: number;
    /** @format int32 */
    durationMonths?: number;
    /** @format int32 */
    invoiceStyleFinalId?: number;
    finalInvoiceStyle?: string | null;
    finalInvoiceDescription?: string | null;
    /** @format int32 */
    invoiceTypeId?: number;
    invoiceType?: string | null;
    invoiceTypeDescription?: string | null;
    proposalConverted?: boolean;
    milestoneInvoice?: boolean;
    /** @format int32 */
    invoiceStyleDraftId?: number;
    draftInvoiceStyle?: string | null;
    draftInvoiceDescription?: string | null;
    /** @format int32 */
    defaultCityStateId?: number;
    /** @format int32 */
    cityStateId?: number;
    city?: string | null;
    /** @format int32 */
    stateCodeId?: number;
    stateCode?: string | null;
    stateName?: string | null;
    country?: string | null;
    inRosterToEnter?: boolean;
    /** @format int32 */
    billingTermId?: number;
    /** @format int32 */
    projectManagerId?: number;
    phaseCharge?: boolean;
    workPackageCodeCharge?: boolean;
    taskCodeCharge?: boolean;
    workLocationCharge?: boolean;
    budgetYearRequired?: boolean;
    /** @format date-time */
    profileChangeDate?: string;
    assignContact?: string | null;
    contactPhone?: string | null;
    contactEmail?: string | null;
    billingName?: string | null;
    billingNameTitle?: string | null;
    billingAddress1?: string | null;
    billingAddress2?: string | null;
    billingAddress3?: string | null;
    billingComment?: string | null;
    receiptRequired?: boolean;
}

export interface AssignmentPhaseModel {
    /** @format int32 */
    assignmentPhaseId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    clientId?: number;
    phaseCode?: string | null;
    phaseDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
    displayName?: string | null;
    active?: boolean;
}

export interface BillingTermModel {
    /** @format int32 */
    billingTermId?: number;
    billingTerm?: string | null;
    shortDescription?: string | null;
    longDescription?: string | null;
    /** @format int32 */
    createdById?: number;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    lastUpdate?: string;
}

export interface BillingTermPostModel {
    /** @format int32 */
    billingTermId?: number;
    billingTerm?: string | null;
    shortDescription?: string | null;
    longDescription?: string | null;
}

export interface BudgetEntriesModel {
    /** @format int32 */
    assignmentBudgetEntryId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    assignmentPhaseId?: number;
    /** @format int32 */
    assignmentWorkPackageId?: number;
    /** @format int32 */
    categoryId?: number;
    /** @format int32 */
    subcategoryGroupId?: number;
    /** @format int32 */
    projectRoleId?: number;
    /** @format double */
    quantity?: number;
    /** @format double */
    billingRate?: number;
    billingRateDisplay?: string | null;
    /** @format double */
    billingAmount?: number;
    billingAmountDisplay?: string | null;
    /** @format double */
    costRate?: number;
    costRateDisplay?: string | null;
    /** @format double */
    costAmount?: number;
    costAmountDisplay?: string | null;
    /** @format double */
    markup?: number;
    /** @format double */
    internalRate?: number;
    internalRateDisplay?: string | null;
    /** @format double */
    internalAmount?: number;
    internalAmountDisplay?: string | null;
    /** @format double */
    incentiveRate?: number;
    billable?: boolean;
    billableDisplay?: string | null;
    invoiceVisible?: boolean;
    invoiceVisibleDisplay?: string | null;
    description?: string | null;
    staffingName?: string | null;
    roleCode?: string | null;
    roleDescription?: string | null;
    assignmentNumber?: string | null;
    assignmentDescription?: string | null;
    assignmentPhaseCode?: string | null;
    assignmentPhaseDescription?: string | null;
    workPackageCode?: string | null;
    workPackageDescription?: string | null;
    taskCode?: string | null;
    taskDescription?: string | null;
    subcategoryGroup?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface BudgetEntryPostModel {
    /** @format int32 */
    id?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    categoryId?: number;
    /** @format int32 */
    subCategoryGroupId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    phaseId?: number;
    /** @format int32 */
    workPackageId?: number;
    /** @format int32 */
    roleId?: number;
    description?: string | null;
    /** @format double */
    quantity?: number;
    invoiceVisible?: boolean;
    billable?: boolean;
}

export interface ChangePasswordPost {
    /** @format int32 */
    staff_id?: number;
    new_password?: string | null;
    old_password?: string | null;
}

export interface CityStateModel {
    /** @format int32 */
    cityStateId?: number;
    city?: string | null;
    stateCode?: string | null;
    workLocation?: boolean;
    /** @format int32 */
    stateCodeId?: number;
}

export interface CityStatePostModel {
    /** @format int32 */
    cityStateId?: number;
    city?: string | null;
    stateCode?: string | null;
    workLocation?: boolean;
    /** @format int32 */
    stateCodeId?: number;
}

export interface ClientCategoryModel {
    /** @format int32 */
    clientCategoryId?: number;
    clientCategory?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface ClientCategoryPostModel {
    /** @format int32 */
    clientCategoryId?: number;
    clientCategory?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface ClientListModel {
    /** @format int32 */
    clientId?: number;
    clientDescription?: string | null;
}

export interface ClientModel {
    /** @format int32 */
    clientId?: number;
    clientNumber?: string | null;
    clientName?: string | null;
    clientNameShort?: string | null;
    address?: AddressModel;
    phone?: string | null;
    fax?: string | null;
    /** @format int32 */
    clientCategoryId?: number;
    /** @format int32 */
    nextInvoiceNumber?: number;
    clientCategory?: string | null;
    receiptRequired?: boolean;
    notes?: string | null;
    active?: boolean;
}

export interface ClientPostModel {
    /** @format int32 */
    clientId?: number;
    clientNumber?: string | null;
    clientName?: string | null;
    clientNameShort?: string | null;
    address?: AddressModel;
    phone?: string | null;
    fax?: string | null;
    /** @format int32 */
    clientCategoryId?: number;
    receiptRequired?: boolean;
    notes?: string | null;
    isActive?: boolean;
}

export interface CompleteAssignmentModel {
    assignment?: AssignmentModel;
}

export interface ConfirmEMailPost {
    token?: string | null;
}

export interface ConvertAssignmentPostModel {
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    createdById?: number;
}

export interface CostRateModel {
    /** @format double */
    costRate?: number;
    costRateDisplay?: string | null;
}

export interface EntriesTotalModel {
    /** @format double */
    quantityTotal?: number;
    quantityTotalDisplay?: string | null;
    /** @format double */
    costAmountTotal?: number;
    costAmountTotalDisplay?: string | null;
    /** @format double */
    billingAmountTotal?: number;
    billingAmountTotalDisplay?: string | null;
    /** @format double */
    internalAmountTotal?: number;
    internalAmountTotalDisplay?: string | null;
}

export interface EntryCategoryModel {
    /** @format int32 */
    categoryId?: number;
    categoryDescription?: string | null;
    mobileDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface EntryCategoryPostModel {
    /** @format int32 */
    categoryId?: number;
    categoryDescription?: string | null;
    mobileDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface EntryModel {
    entryId?: string | null;
    /** @format int32 */
    staffId?: number;
    firstName?: string | null;
    lastName?: string | null;
    staffName?: string | null;
    /** @format int32 */
    assignmentId?: number;
    assignNum?: string | null;
    assignDescription?: string | null;
    /** @format int32 */
    clientId?: number;
    clientNumber?: string | null;
    clientName?: string | null;
    clientNameShort?: string | null;
    /** @format date-time */
    startDate?: string;
    startDateDisplay?: string | null;
    /** @format int32 */
    phaseId?: number;
    phaseCode?: string | null;
    /** @format int32 */
    workPackageId?: number;
    workPackageCode?: string | null;
    workPackageDescription?: string | null;
    taskCode?: string | null;
    taskDescription?: string | null;
    /** @format date-time */
    itemDate?: string;
    itemDateDisplay?: string | null;
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    category?: number;
    categoryDescription?: string | null;
    subcategory?: string | null;
    description?: string | null;
    /** @format double */
    quantity?: number;
    quantityDisplay?: string | null;
    /** @format int32 */
    workLocationId?: number;
    workLocationCity?: string | null;
    workLocationState?: string | null;
    isBillable?: boolean;
    isBillableDisplay?: string | null;
    isReimbursable?: boolean;
    isReimbursableDisplay?: string | null;
    isInvoiceVisible?: boolean;
    isInvoiceVisibleDisplay?: string | null;
    /** @format double */
    costRate?: number;
    costRateDisplay?: string | null;
    /** @format double */
    costAmount?: number;
    costAmountDisplay?: string | null;
    /** @format double */
    markup?: number;
    /** @format double */
    billingRate?: number;
    billingRateDisplay?: string | null;
    /** @format double */
    billingAmount?: number;
    billingAmountDisplay?: string | null;
    /** @format double */
    internalRate?: number;
    internalRateDisplay?: string | null;
    /** @format double */
    internalAmount?: number;
    internalAmountDisplay?: string | null;
    /** @format double */
    incentiveRate?: number;
    accountingCode?: string | null;
    isPosted?: boolean;
    isPostedDisplay?: string | null;
    /** @format int32 */
    postedId?: number;
    /** @format date-time */
    postedDate?: string;
    /** @format int32 */
    invoiceId?: number;
    /** @format date-time */
    invoicedDate?: string;
    /** @format int32 */
    invoicerId?: number;
    invoicerFirstName?: string | null;
    invoicerLastName?: string | null;
    /** @format date-time */
    receiptUploadedDate?: string;
    isReceiptUploaded?: boolean;
    receiptName?: string | null;
    isReceiptRequired?: boolean;
}

export interface EntryPostModel {
    entryId?: string | null;
    /** @format int32 */
    categoryId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    phaseId?: number;
    /** @format int32 */
    workPackageId?: number;
    fromDate?: string | null;
    toDate?: string | null;
    /** @format int32 */
    subCategoryId?: number;
    quantityRate?: boolean;
    /** @format int32 */
    workLocationId?: number;
    description?: string | null;
    /** @format double */
    quantity?: number;
    billable?: boolean;
    reimbursable?: boolean;
    isPosted?: boolean;
    invoiceVisible?: boolean;
    /** @format double */
    costAmount?: number;
}

export interface ExpenseDetailsModel {
    /** @format int32 */
    assignmentExpenseDetailId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    subCategoryId?: number;
    subCategory?: string | null;
    /** @format int32 */
    categoryId?: number;
    category?: string | null;
    /** @format date-time */
    effectiveDate?: string;
    reimbursable?: boolean;
    billable?: boolean;
    invoiceVisible?: boolean;
    /** @format double */
    markupAmount?: number;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    effectiveDateDisplay?: string | null;
    reimbursableDisplay?: string | null;
    billableDisplay?: string | null;
    invoiceVisibleDisplay?: string | null;
    markupAmountDisplay?: string | null;
    costRateDisplay?: string | null;
    billingRateDisplay?: string | null;
    internalRateDisplay?: string | null;
}

export interface ExpenseResponse {
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    timeReimbursable?: boolean;
}

export interface ExtensionModel {
    /** @format int32 */
    extensionId?: number;
    extension?: string | null;
    description?: string | null;
    nextExtension?: string | null;
    displayName?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface ExtensionPostModel {
    /** @format int32 */
    extensionId?: number;
    extension?: string | null;
    description?: string | null;
    nextExtension?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface FinalizeInvoicePostModel {
    /** @format int32 */
    invoiceId?: number;
}

export interface FullTimeEmployeeModel {
    /** @format int32 */
    fullTimeEmployeeId?: number;
    calendarYear?: string | null;
    /** @format int32 */
    calendarMonth?: number;
    /** @format double */
    fteEmployee?: number;
    /** @format double */
    fteConsultant?: number;
    /** @format int32 */
    lineNumber?: number;
    /** @format int32 */
    sortBy?: number;
    /** @format int32 */
    createdById?: number;
    /** @format int32 */
    lastUpdateId?: number;
}

export interface FullTimeEmployeePostModel {
    /** @format int32 */
    fullTimeEmployeeId?: number;
    calendarYear?: string | null;
    /** @format int32 */
    calendarMonth?: number;
    /** @format double */
    fteEmployee?: number;
    /** @format double */
    fteConsultant?: number;
    /** @format int32 */
    lineNumber?: number;
    /** @format int32 */
    sortBy?: number;
}

export interface InsertAdjustmentPostModel {
    /** @format int32 */
    invoiceId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format double */
    amount?: number;
    comment?: string | null;
    /** @format int32 */
    createdById?: number;
}

export interface InsertAssignmentPostModel {
    /** @format int32 */
    assignmentId?: number;
    startDate?: string | null;
    duration?: string | null;
    description?: string | null;
    inRoster?: boolean;
    workPackageRequired?: boolean;
    workLocationRequired?: boolean;
    workPhaseRequired?: boolean;
    taskCodeRequired?: boolean;
    yearRequired?: boolean;
    isActive?: boolean;
    workLocationId?: string | null;
    defaultWorkLocationStateId?: string | null;
    defaultWorkLocationCityName?: string | null;
    utilizationCodeId?: string | null;
    projectManagerId?: string | null;
    clientId?: string | null;
    extensionId?: string | null;
}

export interface InsertAssignmentResponseModel {
    /** @format int32 */
    assignmentId?: number;
    assignmentNumber?: string | null;
}

export interface InsertAssignmentRosterStaffPostModel {
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    projectRoleId?: number;
}

export interface InsertInvoicePostModel {
    /** @format int32 */
    assignmentId?: number;
    startDt?: string | null;
    endDt?: string | null;
    invoiceDt?: string | null;
    /** @format int32 */
    invoiceTypeId?: number;
    comment?: string | null;
}

export interface InsertPotentialEntryPostModel {
    entries?: string[] | null;
    /** @format int32 */
    invoiceId?: number;
    /** @format int32 */
    invoicerId?: number;
}

export interface InsertWorkLocationPostModel {
    /** @format int32 */
    assignmentId?: number;
    workLocationId?: string | null;
    stateId?: string | null;
    cityName?: string | null;
}

export interface InsertWorkPackagePostModel {
    /** @format int32 */
    assignmentPhaseId?: number;
    packageCode?: string | null;
    packageDescription?: string | null;
}

export interface InvoiceAdjustmentModel {
    /** @format int32 */
    invoiceAdjustmentId?: number;
    /** @format int32 */
    invoiceId?: number;
    /** @format int32 */
    subcategoryId?: number;
    subcategory?: string | null;
    /** @format int32 */
    categoryId?: number;
    category?: string | null;
    /** @format double */
    amount?: number;
    amountDisplay?: string | null;
    comment?: string | null;
    /** @format int32 */
    createdById?: number;
    createdBy?: string | null;
    /** @format date-time */
    createdDate?: string;
    createdDateDisplay?: string | null;
}

export interface InvoiceModel {
    /** @format int32 */
    invoiceId?: number;
    invoiceNumber?: string | null;
    /** @format int32 */
    assignmentId?: number;
    assignmentNumber?: string | null;
    assignmentDescription?: string | null;
    /** @format date-time */
    startDate?: string;
    startDateDisplay?: string | null;
    /** @format date-time */
    endDate?: string;
    endDateDisplay?: string | null;
    /** @format date-time */
    invoiceDate?: string;
    invoiceDateDisplay?: string | null;
    /** @format int32 */
    invoiceTypeId?: number;
    invoiceType?: string | null;
    comment?: string | null;
    finalized?: boolean;
    finalizedDisplay?: string | null;
    creatorName?: string | null;
    invoiceAmount?: number;
    otherExpensesAmount?: number;
    travelExpenseAmount?: number;
    timeCostAmount?: number;
}

export interface InvoiceStyleModel {
    /** @format int32 */
    invoiceStyleId?: number;
    invoiceStyle?: string | null;
    description?: string | null;
    /** @format int32 */
    createdById?: number;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    lastUpdate?: string;
}

export interface InvoiceStylePostModel {
    /** @format int32 */
    invoiceStyleId?: number;
    invoiceStyle?: string | null;
    description?: string | null;
}

export interface InvoiceTypeModel {
    /** @format int32 */
    invoiceTypeId?: number;
    invoiceType?: string | null;
    invoiceTypeDescription?: string | null;
    milestoneInvoice?: boolean;
    /** @format int32 */
    sortBy?: number;
    /** @format int32 */
    createdById?: number;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    lastUpdate?: string;
}

export interface InvoiceTypePostModel {
    /** @format int32 */
    invoiceTypeId?: number;
    invoiceType?: string | null;
    invoiceTypeDescription?: string | null;
    milestoneInvoice?: boolean;
    /** @format int32 */
    sortBy?: number;
}

export interface MembershipRoleModel {
    roleId?: string | null;
    roleName?: string | null;
}

export interface MoveUpDownSortByRecordPostModel {
    operation?: string | null;
    id?: string | null;
    tblName?: string | null;
    primeKey?: string | null;
}

export interface NewPasswordPost {
    /** @format int32 */
    staff_id?: number;
    new_password?: string | null;
}

export interface OutstandingChargesModel {
    /** @format int32 */
    assignmentId?: number;
    assignmentNumber?: string | null;
    assignmentDescription?: string | null;
    /** @format double */
    entriesThisMonth?: number;
    entriesThisMonthDisplay?: string | null;
    /** @format double */
    invoiced?: number;
    invoicedDisplay?: string | null;
    /** @format double */
    budget?: number;
    budgetDisplay?: string | null;
    active?: boolean;
    /** @format int32 */
    utilizationCodeId?: number;
}

export interface PerformanceModel {
    /** @format int32 */
    performanceId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format date-time */
    effectiveDate?: string;
    effectiveDateDisplay?: string | null;
    /** @format double */
    targetUtilizationRate?: number;
    targetUtilizationRateDisplay?: string | null;
    /** @format double */
    targetBillingRate?: number;
    targetBillingRateDisplay?: string | null;
}

export interface PostingEntriesPostModel {
    ids?: string | null;
}

export interface PowerBIReportAccessModel {
    accessToken?: string | null;
    reportUrl?: string | null;
}

export interface PowerBISettingModel {
    /** @format int32 */
    powerBISettingID?: number;
    powerBIServerUrl?: string | null;
    powerBIAuthorityUrl?: string | null;
    /** @format uuid */
    powerBIWorkspaceGuid?: string;
    /** @format uuid */
    powerBITenantGuid?: string;
    /** @format uuid */
    powerBIClientGuid?: string;
    powerBIClientSecret?: string | null;
    powerBIUserOverride?: string | null;
}

export interface ProjectRoleModel {
    /** @format int32 */
    projectRoleId?: number;
    roleCode?: string | null;
    roleDescription?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface ProjectRolePostModel {
    /** @format int32 */
    projectRoleId?: number;
    roleCode?: string | null;
    roleDescription?: string | null;
}

export interface ReimbursableExpenseExceptionModel {
    /** @format int32 */
    reimbursableExpenseExceptionId?: number;
    firstName?: string | null;
    lastName?: string | null;
    subcategory?: string | null;
    categoryDescription?: string | null;
    reimbursable?: boolean;
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    createdById?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    lastUpdate?: string;
}

export interface ReimbursableExpenseExceptionPostModel {
    /** @format int32 */
    reimbursableExpenseExceptionId?: number;
    firstName?: string | null;
    lastName?: string | null;
    subcategory?: string | null;
    categoryDescription?: string | null;
    reimbursable?: boolean;
    /** @format int32 */
    staffId?: number;
    /** @format int32 */
    subcategoryId?: number;
}

export interface ReportUiModel {
    /** @format int32 */
    reportId?: number;
    reportPage?: boolean;
    reportName?: string | null;
    startDate?: boolean;
    endDate?: boolean;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    staffId?: number;
    amountTypeId?: boolean;
    sortingId?: boolean;
    posted?: boolean;
    billable?: boolean;
    billableAssignments?: boolean;
    active?: boolean;
    invoiceVisible?: boolean;
    invoiceId?: boolean;
    invoiced?: boolean;
    staffType?: boolean;
    utiliCode?: boolean;
    useLogo?: boolean;
    groups?: boolean;
    /** @format int32 */
    sortType?: number;
    reportPath?: string | null;
    forStaffOnly?: boolean;
}

export interface RequestResetPasswordPost {
    user_name?: string | null;
}

export interface ResetPasswordPost {
    /** @format int32 */
    staff_id?: number;
    new_password?: string | null;
    user_name?: string | null;
    reset_password_token?: string | null;
}

export interface RosterDetailsModel {
    /** @format int32 */
    rosterDetailId?: number;
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format date-time */
    effectiveDate?: string;
    timeReimbursable?: boolean;
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    /** @format double */
    incentiveRate?: number;
    effectiveDateDisplay?: string | null;
    costRateDisplay?: string | null;
    billingRateDisplay?: string | null;
    internalRateDisplay?: string | null;
    incentiveRateDisplay?: string | null;
}

export interface RostersModel {
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    staffId?: number;
    fullName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    /** @format int32 */
    sortBy?: number;
    displayName?: string | null;
    active?: boolean;
    /** @format int32 */
    projectRoleId?: number;
    roleName?: string | null;
    hasBudget?: boolean;
}

export interface SetupCategoryModel {
    /** @format int32 */
    setupCategoryId?: number;
    description?: string | null;
}

export interface SetupDetailModel {
    /** @format int32 */
    setupDetailId?: number;
    /** @format int32 */
    setupCategoryId?: number;
    description?: string | null;
    systemInformation?: boolean;
    internalName?: string | null;
    operAdd?: boolean;
    operDelete?: boolean;
    operEdit?: boolean;
    operDetail?: boolean;
    operFilter?: boolean;
    operSort?: boolean;
    spLoad?: string | null;
    spSave?: string | null;
    spMove?: string | null;
    spSort?: string | null;
    tableName?: string | null;
    defSortName?: string | null;
    sortByTblName?: string | null;
    sortByPrimeKey?: string | null;
}

export interface StaffAssignmentModel {
    /** @format int32 */
    assignmentId?: number;
    displayName?: string | null;
    /** @format int32 */
    clientId?: number;
    clientName?: string | null;
    workPackageCodeCharge?: boolean;
    taskCodeCharge?: boolean;
    workLocationCharge?: boolean;
    /** @format date-time */
    startDate?: string;
}

export interface StaffCompanyModel {
    /** @format int32 */
    staffCompanyId?: number;
    companyName?: string | null;
    /** @format int32 */
    addressId?: number;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateCode?: string | null;
    postalCode?: string | null;
    phoneNumber?: string | null;
    faxNumber?: string | null;
    email?: string | null;
    webSite?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface StaffContactPostModel {
    /** @format int32 */
    staffingId?: number;
    roleId?: string | null;
    email?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    title?: string | null;
    /** @format int32 */
    staffCompanyId?: number;
    initials?: string | null;
    isActive?: boolean;
    isHourly?: boolean;
    address?: AddressModel;
    homePhone?: string | null;
    homeFax?: string | null;
    workPhone?: string | null;
    workFax?: string | null;
}

export interface StaffNotificationPostModel {
    /** @format int32 */
    staffingId?: number;
    /** @format int32 */
    numberDaysReminderEmail?: number;
    send15thReminderEmail?: boolean;
    sendLastDayReminderEmail?: boolean;
}

export interface StaffPerformancePostModel {
    /** @format int32 */
    performanceId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format date-time */
    effectiveDate?: string;
    targetBillingRate?: string | null;
    targetUtilizationRate?: string | null;
}

export interface StaffPersonalPostModel {
    /** @format int32 */
    staffingId?: number;
    hiredDate?: string | null;
    terminationDate?: string | null;
    birthDate?: string | null;
    spouseName?: string | null;
    emergContactName?: string | null;
    emergContactPhone?: string | null;
    socialSecurityNumber?: string | null;
    staffImage?: string | null;
    notes?: string | null;
}

export interface StaffProfilePostModel {
    /** @format int32 */
    staffingId?: number;
    assignments?: string | null;
    /** @format int32 */
    utilId?: number;
}

export interface StaffRatePostModel {
    /** @format int32 */
    staffDetailId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format date-time */
    effectiveDate?: string;
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    costRate?: string | null;
    billingRate?: string | null;
    internalRate?: string | null;
    /** @format double */
    incentiveRate?: number;
    /** @format double */
    averageHoursPerDay?: number;
}

export interface StaffingDetailsModel {
    /** @format int32 */
    staffDetailId?: number;
    /** @format int32 */
    staffId?: number;
    /** @format date-time */
    effectiveDate?: string;
    billableTime?: boolean;
    billableTravelExpense?: boolean;
    billableOtherIndividualExpense?: boolean;
    billableOfficeExpense?: boolean;
    invoiceVisibleTime?: boolean;
    invoiceVisibleTravelExpense?: boolean;
    invoiceVisibleOtherIndividualExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    /** @format double */
    incentiveRate?: number;
    /** @format double */
    averageHoursPerDay?: number;
    billingRateDisplay?: string | null;
    costRateDisplay?: string | null;
    internalRateDisplay?: string | null;
    effectiveDateDisplay?: string | null;
}

export interface StaffingModel {
    /** @format int32 */
    staffingId?: number;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    /** @format int32 */
    staffCompanyId?: number;
    /** @format int32 */
    managerId?: number;
    initials?: string | null;
    fullName?: string | null;
    isActive?: boolean;
    isHourly?: boolean;
    /** @format date-time */
    hiredDate?: string;
    address?: AddressModel;
    /** @format date-time */
    terminationDate?: string;
    socialSecurityNumber?: string | null;
    title?: string | null;
    homePhone?: string | null;
    homeFax?: string | null;
    workPhone?: string | null;
    workFax?: string | null;
    /** @format date-time */
    birthDate?: string;
    spouseName?: string | null;
    emergContactName?: string | null;
    emergContactPhone?: string | null;
    notes?: string | null;
    /** @format date-time */
    lastLogin?: string;
    isBuiltIn?: boolean;
    membershipUserId?: string | null;
    email?: string | null;
    roleId?: string | null;
    roleName?: string | null;
    imageName?: string | null;
    active?: boolean;
    /** @format int32 */
    numberDaysReminderEmail?: number;
    send15thReminderEmail?: boolean;
    sendLastDayReminderEmail?: boolean;
    birthDateDisplay?: string | null;
    hiredDateDisplay?: string | null;
    terminationDateDisplay?: string | null;
}

export interface StaffingRosterModel {
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format date-time */
    assignmentStart?: string;
    assignmentName?: string | null;
    clientName?: string | null;
    mustBeInRosterToEnter?: boolean;
    isInRoster?: boolean;
    isSelected?: boolean;
    displayName?: string | null;
}

export interface StateCodeModel {
    /** @format int32 */
    stateCodeId?: number;
    stateCode?: string | null;
    stateName?: string | null;
    countryName?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface StateCodePostModel {
    /** @format int32 */
    stateCodeId?: number;
    stateCode?: string | null;
    stateName?: string | null;
    countryName?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface SubCategoryAccountingDetailModel {
    /** @format int32 */
    lAccountingCategoriesCode_id?: number;
    /** @format int32 */
    lSubcategory_id?: number;
    /** @format int32 */
    lAccountCode_id?: number;
    /** @format int32 */
    lAccountingCategory_id?: number;
    szAccountingCode?: string | null;
    szAccountingCodeDescription?: string | null;
    szAccountingCategory?: string | null;
    /** @format int32 */
    accountingCategoriesCodeId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    accountingCategoryId?: number;
    /** @format int32 */
    accountCodeId?: number;
    accountingCategory?: string | null;
    accountingCode?: string | null;
    accountingCodeDescription?: string | null;
}

export interface SubCategoryAccountingDetailPostModel {
    /** @format int32 */
    accountingCategoriesCodeId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    accountingCategoryId?: number;
    /** @format int32 */
    accountCodeId?: number;
    accountingCategory?: string | null;
    accountingCode?: string | null;
    accountingCodeDescription?: string | null;
}

export interface SubCategoryDefaultRateModel {
    /** @format int32 */
    expenseSubcategoryDetailId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format date-time */
    effectiveDate?: string;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    /** @format double */
    markup?: number;
    reimbursable?: boolean;
}

export interface SubCategoryDefaultRatePostModel {
    /** @format int32 */
    expenseSubcategoryDetailId?: number;
    /** @format int32 */
    subcategoryId?: number;
    /** @format date-time */
    effectiveDate?: string;
    /** @format double */
    costRate?: number;
    /** @format double */
    billingRate?: number;
    /** @format double */
    internalRate?: number;
    /** @format double */
    markup?: number;
    reimbursable?: boolean;
}

export interface SubCategoryGroupModel {
    /** @format int32 */
    subcategoryGroupId?: number;
    /** @format int32 */
    categoryId?: number;
    name?: string | null;
    categoryDescription?: string | null;
    description?: string | null;
    billable?: boolean;
    invoiceVisible?: boolean;
    /** @format int32 */
    sortBy?: number;
}

export interface SubCategoryGroupPostModel {
    /** @format int32 */
    subcategoryGroupId?: number;
    /** @format int32 */
    categoryId?: number;
    name?: string | null;
    categoryDescription?: string | null;
    description?: string | null;
    billable?: boolean;
    invoiceVisible?: boolean;
    /** @format int32 */
    sortBy?: number;
}

export interface SubCategoryModel {
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    categoryId?: number;
    subcategoryDescription?: string | null;
    /** @format int32 */
    groupId?: number;
    subcategoryGroupName?: string | null;
    categoryDescription?: string | null;
    quantityRate?: boolean;
    receiptRequired?: boolean;
    /** @format int32 */
    sortBy?: number;
    active?: boolean;
}

export interface SubCategoryPostModel {
    /** @format int32 */
    subcategoryId?: number;
    /** @format int32 */
    categoryId?: number;
    subcategoryDescription?: string | null;
    /** @format int32 */
    groupId?: number;
    subcategoryGroupName?: string | null;
    categoryDescription?: string | null;
    quantityRate?: boolean;
    receiptRequired?: boolean;
    /** @format int32 */
    sortBy?: number;
    active?: boolean;
}

export interface SystemInfoModel {
    multiUser?: boolean;
    tempTableMode?: boolean;
    installationDate?: string | null;
    expirationDate?: string | null;
    companyName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    telephone?: string | null;
    fax?: string | null;
    email?: string | null;
    federalTaxId?: string | null;
    /** @format int32 */
    reserveLowerBound?: number;
    /** @format int32 */
    reserveUpperBound?: number;
    /** @format int32 */
    periodsPerMonth?: number;
    /** @format double */
    fullTimeHoursPerDay?: number;
    /** @format double */
    maxTimeQuantity?: number;
    /** @format double */
    maxTravel?: number;
    /** @format double */
    maxOtherIndiv?: number;
    /** @format double */
    maxOffice?: number;
    /** @format double */
    maxInvoiceTime?: number;
    /** @format double */
    maxInvoiceTravel?: number;
    /** @format double */
    maxInvoiceOtherIndiv?: number;
    /** @format double */
    maxInvoiceOffice?: number;
    /** @format int32 */
    maxYearInterval?: number;
    version?: string | null;
    /** @format int32 */
    createdBy_id?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format int32 */
    lastUpdate_id?: number;
    /** @format date-time */
    lastUpdate?: string;
}

export interface SystemInfoPostModel {
    multiUser?: boolean;
    tempTableMode?: boolean;
    installationDate?: string | null;
    expirationDate?: string | null;
    companyName?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    telephone?: string | null;
    fax?: string | null;
    email?: string | null;
    federalTaxId?: string | null;
    /** @format int32 */
    reserveLowerBound?: number;
    /** @format int32 */
    reserveUpperBound?: number;
    /** @format int32 */
    periodsPerMonth?: number;
    /** @format double */
    fullTimeHoursPerDay?: number;
    /** @format double */
    maxTimeQuantity?: number;
    /** @format double */
    maxTravel?: number;
    /** @format double */
    maxOtherIndiv?: number;
    /** @format double */
    maxOffice?: number;
    /** @format double */
    maxInvoiceTime?: number;
    /** @format double */
    maxInvoiceTravel?: number;
    /** @format double */
    maxInvoiceOtherIndiv?: number;
    /** @format double */
    maxInvoiceOffice?: number;
    /** @format int32 */
    maxYearInterval?: number;
    version?: string | null;
}

export interface TaskCodeModel {
    /** @format int32 */
    taskCodeId?: number;
    taskCode?: string | null;
    taskDescription?: string | null;
    displayName?: string | null;
    isActive?: boolean;
}

export interface UpdateAssignmentPhaseActivationPostModel {
    /** @format int32 */
    phaseId?: number;
    isActive?: boolean;
}

export interface UpdateAssignmentPhaseSortOrderPostModel {
    /** @format int32 */
    phaseId?: number;
    /** @format int32 */
    sortBy?: number;
}

export interface UpdateAssignmentWorkLocationActivationPostModel {
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    locationId?: number;
    isActive?: boolean;
}

export interface UpdateBillingPostModel {
    /** @format int32 */
    assignmentId?: number;
    billingContactName?: string | null;
    billingContactEmail?: string | null;
    billingContactPhone?: string | null;
    billingAddressName?: string | null;
    billingAddressTitle?: string | null;
    billingAddressLine1?: string | null;
    billingAddressLine2?: string | null;
    billingAddressLine3?: string | null;
    billingComment?: string | null;
    billingTermsId?: string | null;
    invoiceTypesId?: string | null;
    draftStylesId?: string | null;
    finalStylesId?: string | null;
}

export interface UpdateClientActivationPostModel {
    /** @format int32 */
    clientId?: number;
    isActive?: boolean;
}

export interface UpdateGeneralPostModel {
    /** @format int32 */
    assignmentId?: number;
    startDate?: string | null;
    duration?: string | null;
    description?: string | null;
    inRoster?: boolean;
    workPackageRequired?: boolean;
    workLocationRequired?: boolean;
    workPhaseRequired?: boolean;
    taskCodeRequired?: boolean;
    yearRequired?: boolean;
    isActive?: boolean;
    workLocationId?: string | null;
    defaultWorkLocationStateId?: string | null;
    defaultWorkLocationCityName?: string | null;
    utilizationCodeId?: string | null;
    projectManagerId?: string | null;
}

export interface UpdateInvoicePostModel {
    /** @format int32 */
    invoiceId?: number;
    startDt?: string | null;
    endDt?: string | null;
    invoiceDt?: string | null;
    comment?: string | null;
}

export interface UpdatePowerBISecretSettingPutModel {
    powerBIClientSecret?: string | null;
}

export interface UpdatePowerBITenantSettingPutModel {
    powerBITenantGuid?: string | null;
    powerBIClientGuid?: string | null;
    powerBIUserOverride?: string | null;
}

export interface UpdateRosterStaffActivationPostModel {
    /** @format int32 */
    rosterId?: number;
    isActive?: boolean;
}

export interface UpdateRosterStaffProjectRolePostModel {
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    projectRoleId?: number;
}

export interface UpdateRosterStaffSortByPostModel {
    /** @format int32 */
    rosterId?: number;
    /** @format int32 */
    sortBy?: number;
}

export interface UpdateStatusPostModel {
    /** @format int32 */
    assignmentId?: number;
    isEnabled?: boolean;
}

export interface UpdateWorkPackageActivationPostModel {
    /** @format int32 */
    workPackageId?: number;
    isActive?: boolean;
}

export interface UpdateWorkPackagePostModel {
    /** @format int32 */
    workPackageId?: number;
    packageCode?: string | null;
    packageDescription?: string | null;
}

export interface UpdateWorkPackageSortOrderPostModel {
    /** @format int32 */
    packageId?: number;
    /** @format int32 */
    sortBy?: number;
}

export interface UtilizationCodeModel {
    /** @format int32 */
    utilizationCodeId?: number;
    utilCode?: string | null;
    utilDescription?: string | null;
    /** @format int32 */
    accountingCategoryId?: number;
    accountingCategory?: string | null;
    invoiceBillableHoursFees?: boolean;
    invoiceBillableIndividualExpense?: boolean;
    invoiceBillableOtherExpense?: boolean;
    invoiceBillableOfficeExpense?: boolean;
    invoiceVisibleHoursFees?: boolean;
    invoiceVisibleIndividualExpense?: boolean;
    invoiceVisibleOtherExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format int32 */
    defaultExtensionId?: number;
    extension?: string | null;
    /** @format int32 */
    defaultInvoiceTypeId?: number;
    invoiceType?: string | null;
    /** @format int32 */
    defaultBillingTermId?: number;
    billingTerm?: string | null;
    /** @format int32 */
    sortBy?: number;
    displayName?: string | null;
    /** @format int32 */
    createdById?: number;
    /** @format int32 */
    lastUpdateId?: number;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    lastUpdate?: string;
}

export interface UtilizationCodePostModel {
    /** @format int32 */
    utilizationCodeId?: number;
    utilCode?: string | null;
    utilDescription?: string | null;
    /** @format int32 */
    accountingCategoryId?: number;
    accountingCategory?: string | null;
    invoiceBillableHoursFees?: boolean;
    invoiceBillableIndividualExpense?: boolean;
    invoiceBillableOtherExpense?: boolean;
    invoiceBillableOfficeExpense?: boolean;
    invoiceVisibleHoursFees?: boolean;
    invoiceVisibleIndividualExpense?: boolean;
    invoiceVisibleOtherExpense?: boolean;
    invoiceVisibleOfficeExpense?: boolean;
    /** @format int32 */
    defaultExtensionId?: number;
    extension?: string | null;
    /** @format int32 */
    defaultInvoiceTypeId?: number;
    invoiceType?: string | null;
    /** @format int32 */
    defaultBillingTermId?: number;
    billingTerm?: string | null;
    /** @format int32 */
    sortBy?: number;
}

export interface WorkLocationModel {
    /** @format int32 */
    locationId?: number;
    /** @format int32 */
    assignmentId?: number;
    /** @format int32 */
    cityStateId?: number;
    city?: string | null;
    /** @format int32 */
    stateCodeId?: number;
    stateCode?: string | null;
    stateName?: string | null;
    country?: string | null;
    active?: boolean;
    displayName?: string | null;
}

export interface WorkPackageModel {
    /** @format int32 */
    workPackageId?: number;
    /** @format int32 */
    assignmentPhaseId?: number;
    /** @format int32 */
    assignmentId?: number;
    workPackageCode?: string | null;
    workPackageDescription?: string | null;
    phaseCode?: string | null;
    displayName?: string | null;
    active?: boolean;
    /** @format int32 */
    sortBy?: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
    securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = "application/json",
    FormData = "multipart/form-data",
    UrlEncoded = "application/x-www-form-urlencoded",
    Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = "";
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: "same-origin",
        headers: {},
        redirect: "follow",
        referrerPolicy: "no-referrer",
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
        return keys
            .map((key) =>
                Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key),
            )
            .join("&");
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : "";
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== "string" ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === "object" && property !== null
                          ? JSON.stringify(property)
                          : `${property}`,
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    };

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<T> => {
        const secureParams =
            ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter = this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
            body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
        }).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data.data;
        });
    };
}

/**
 * @title Schuco Teirs Engine Api
 * @version 3.1.5
 */
export class EngineApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    assignment = {
        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetWpCodeRequiredDetail
         * @request GET:/api/Assignment/{assignmentId}/GetWPCodeRequired
         */
        assignmentGetWpCodeRequiredDetail: (assignmentId: number, params: RequestParams = {}) =>
            this.request<boolean, any>({
                path: `/api/Assignment/${assignmentId}/GetWPCodeRequired`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetAssignmentInvoiceTypeDetail
         * @request GET:/api/Assignment/GetAssignmentInvoiceType/{assignmentId}
         */
        assignmentGetAssignmentInvoiceTypeDetail: (assignmentId: number, params: RequestParams = {}) =>
            this.request<InvoiceTypeModel, any>({
                path: `/api/Assignment/GetAssignmentInvoiceType/${assignmentId}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetAssignmentsListList
         * @request GET:/api/Assignment/GetAssignmentsList
         */
        assignmentGetAssignmentsListList: (
            query?: {
                /** @format int32 */
                ClientId?: number;
                Extension?: string;
                ActiveState?: ActiveEnums;
                SearchDesc?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentModel[], any>({
                path: `/api/Assignment/GetAssignmentsList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetInvoiceAssignmentsListList
         * @request GET:/api/Assignment/GetInvoiceAssignmentsList
         */
        assignmentGetInvoiceAssignmentsListList: (params: RequestParams = {}) =>
            this.request<AssignmentMiniModel[], any>({
                path: `/api/Assignment/GetInvoiceAssignmentsList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetAssignmentBillingCommentDetail
         * @request GET:/api/Assignment/GetAssignmentBillingComment/{assignmentId}
         */
        assignmentGetAssignmentBillingCommentDetail: (assignmentId: number, params: RequestParams = {}) =>
            this.request<string, any>({
                path: `/api/Assignment/GetAssignmentBillingComment/${assignmentId}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetCompleteAssignmentList
         * @request GET:/api/Assignment/GetCompleteAssignment
         */
        assignmentGetCompleteAssignmentList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<CompleteAssignmentModel, any>({
                path: `/api/Assignment/GetCompleteAssignment`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetWorkLocationsListList
         * @request GET:/api/Assignment/GetWorkLocationsList
         */
        assignmentGetWorkLocationsListList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkLocationModel[], any>({
                path: `/api/Assignment/GetWorkLocationsList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetRosterDetailList
         * @request GET:/api/Assignment/GetRosterDetail
         */
        assignmentGetRosterDetailList: (
            query?: {
                /** @format int32 */
                rosterDetailId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<RosterDetailsModel, any>({
                path: `/api/Assignment/GetRosterDetail`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetAssignmentRosterListList
         * @request GET:/api/Assignment/GetAssignmentRosterList
         */
        assignmentGetAssignmentRosterListList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                activeState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<RostersModel[], any>({
                path: `/api/Assignment/GetAssignmentRosterList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentGetAssignmentRosterDetailListList
         * @request GET:/api/Assignment/GetAssignmentRosterDetailList
         */
        assignmentGetAssignmentRosterDetailListList: (
            query?: {
                /** @format int32 */
                rosterId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<RosterDetailsModel[], any>({
                path: `/api/Assignment/GetAssignmentRosterDetailList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentCreateAssignmentFromProposalCreate
         * @request POST:/api/Assignment/CreateAssignmentFromProposal
         */
        assignmentCreateAssignmentFromProposalCreate: (data: ConvertAssignmentPostModel, params: RequestParams = {}) =>
            this.request<number, any>({
                path: `/api/Assignment/CreateAssignmentFromProposal`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentInsertAssignmentCreate
         * @request POST:/api/Assignment/InsertAssignment
         */
        assignmentInsertAssignmentCreate: (data: InsertAssignmentPostModel, params: RequestParams = {}) =>
            this.request<InsertAssignmentResponseModel, any>({
                path: `/api/Assignment/InsertAssignment`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentUpdateGeneralCreate
         * @request POST:/api/Assignment/UpdateGeneral
         */
        assignmentUpdateGeneralCreate: (data: UpdateGeneralPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Assignment/UpdateGeneral`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentUpdateBillingCreate
         * @request POST:/api/Assignment/UpdateBilling
         */
        assignmentUpdateBillingCreate: (data: UpdateBillingPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Assignment/UpdateBilling`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assignment
         * @name AssignmentUpdateStatusPartialUpdate
         * @request PATCH:/api/Assignment/UpdateStatus
         */
        assignmentUpdateStatusPartialUpdate: (data: UpdateStatusPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Assignment/UpdateStatus`,
                method: "PATCH",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetCharts
         * @name AssignmentBudgetChartsDetail
         * @request GET:/api/assignment/{assignmentId}/Budget/Charts
         */
        assignmentBudgetChartsDetail: (
            assignmentId: number,
            query?: {
                staffIds?: string[];
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentBudgetChartModel[], any>({
                path: `/api/assignment/${assignmentId}/Budget/Charts`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetEntry
         * @name AssignmentBudgetEntryDetail
         * @request GET:/api/assignment/BudgetEntry/{id}
         */
        assignmentBudgetEntryDetail: (id: number, params: RequestParams = {}) =>
            this.request<BudgetEntriesModel, any>({
                path: `/api/assignment/BudgetEntry/${id}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetEntry
         * @name AssignmentBudgetEntrySaveCreate
         * @request POST:/api/assignment/BudgetEntry/Save
         */
        assignmentBudgetEntrySaveCreate: (data: BudgetEntryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/assignment/BudgetEntry/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetEntry
         * @name AssignmentBudgetEntryDeleteDelete
         * @request DELETE:/api/assignment/BudgetEntry/Delete
         */
        assignmentBudgetEntryDeleteDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/assignment/BudgetEntry/Delete`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetEntry
         * @name AssignmentBudgetEntrySearchList
         * @request GET:/api/assignment/BudgetEntry/Search
         */
        assignmentBudgetEntrySearchList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                catId?: number;
                /** @format int32 */
                staffId?: number;
                /** @format int32 */
                phaseId?: number;
                /** @format int32 */
                packageId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<BudgetEntriesModel[], any>({
                path: `/api/assignment/BudgetEntry/Search`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentBudgetEntry
         * @name AssignmentBudgetEntrySearchTotalsList
         * @request GET:/api/assignment/BudgetEntry/Search/Totals
         */
        assignmentBudgetEntrySearchTotalsList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                catId?: number;
                /** @format int32 */
                staffId?: number;
                /** @format int32 */
                phaseId?: number;
                /** @format int32 */
                packageId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntriesTotalModel, any>({
                path: `/api/assignment/BudgetEntry/Search/Totals`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentDetail
         * @name AssignmentDetailEntryList
         * @request GET:/api/assignment/detail/Entry
         */
        assignmentDetailEntryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentDetailsModel, any>({
                path: `/api/assignment/detail/Entry`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentDetail
         * @name AssignmentDetailSearchList
         * @request GET:/api/assignment/detail/Search
         */
        assignmentDetailSearchList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                workPackageId?: number;
                /** @format int32 */
                staffId?: number;
                /** @format date-time */
                assignmentDt?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<ExpenseResponse, any>({
                path: `/api/assignment/detail/Search`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentDetail
         * @name AssignmentDetailGridList
         * @request GET:/api/assignment/detail/Grid
         */
        assignmentDetailGridList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentDetailsModel[], any>({
                path: `/api/assignment/detail/Grid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentDetail
         * @name AssignmentDetailSaveCreate
         * @request POST:/api/assignment/detail/Save
         */
        assignmentDetailSaveCreate: (data: AssignmentDetailPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/assignment/detail/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentDetail
         * @name AssignmentDetailDeleteDelete
         * @request DELETE:/api/assignment/detail/Delete
         */
        assignmentDetailDeleteDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/assignment/detail/Delete`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentExpenseDetails
         * @name AssignmentExpenseDetailsEntryList
         * @request GET:/api/assignment/ExpenseDetails/Entry
         */
        assignmentExpenseDetailsEntryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ExpenseDetailsModel, any>({
                path: `/api/assignment/ExpenseDetails/Entry`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentExpenseDetails
         * @name AssignmentExpenseDetailsGridList
         * @request GET:/api/assignment/ExpenseDetails/Grid
         */
        assignmentExpenseDetailsGridList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ExpenseDetailsModel[], any>({
                path: `/api/assignment/ExpenseDetails/Grid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentExpenseDetails
         * @name AssignmentExpenseDetailsSaveCreate
         * @request POST:/api/assignment/ExpenseDetails/Save
         */
        assignmentExpenseDetailsSaveCreate: (data: AssignmentExpenseDetailPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/assignment/ExpenseDetails/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentExpenseDetails
         * @name AssignmentExpenseDetailsDeleteDelete
         * @request DELETE:/api/assignment/ExpenseDetails/Delete
         */
        assignmentExpenseDetailsDeleteDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/assignment/ExpenseDetails/Delete`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseGetAssignmentPhaseList
         * @request GET:/api/assignment/phase/GetAssignmentPhase
         */
        assignmentPhaseGetAssignmentPhaseList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentPhaseModel, any>({
                path: `/api/assignment/phase/GetAssignmentPhase`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseGetAssignmentPhaseListList
         * @request GET:/api/assignment/phase/GetAssignmentPhaseList
         */
        assignmentPhaseGetAssignmentPhaseListList: (
            query?: {
                ids?: string;
                activeOnly?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentPhaseModel[], any>({
                path: `/api/assignment/phase/GetAssignmentPhaseList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseGetAssignmentPhaseGridList
         * @request GET:/api/assignment/phase/GetAssignmentPhaseGrid
         */
        assignmentPhaseGetAssignmentPhaseGridList: (
            query?: {
                /** @format int32 */
                id?: number;
                activeOnly?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentPhaseModel[], any>({
                path: `/api/assignment/phase/GetAssignmentPhaseGrid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseCreateAssignmentPhaseCreate
         * @request POST:/api/assignment/phase/CreateAssignmentPhase
         */
        assignmentPhaseCreateAssignmentPhaseCreate: (data: AddEditPhasePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/assignment/phase/CreateAssignmentPhase`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseUpdateAssignmentPhaseActivationCreate
         * @request POST:/api/assignment/phase/UpdateAssignmentPhaseActivation
         */
        assignmentPhaseUpdateAssignmentPhaseActivationCreate: (
            data: UpdateAssignmentPhaseActivationPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/assignment/phase/UpdateAssignmentPhaseActivation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags AssignmentPhase
         * @name AssignmentPhaseUpdateAssignmentPhaseSortByCreate
         * @request POST:/api/assignment/phase/UpdateAssignmentPhaseSortBy
         */
        assignmentPhaseUpdateAssignmentPhaseSortByCreate: (
            data: UpdateAssignmentPhaseSortOrderPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/assignment/phase/UpdateAssignmentPhaseSortBy`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    category = {
        /**
         * No description
         *
         * @tags Category
         * @name CategoryCategoryListList
         * @request GET:/api/Category/CategoryList
         */
        categoryCategoryListList: (params: RequestParams = {}) =>
            this.request<EntryCategoryModel[], any>({
                path: `/api/Category/CategoryList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySubCategoryListList
         * @request GET:/api/Category/SubCategoryList
         */
        categorySubCategoryListList: (
            query?: {
                /**
                 * @format int32
                 * @default 0
                 */
                categoryId?: number;
                /**
                 * @format int32
                 * @default 0
                 */
                groupId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryModel[], any>({
                path: `/api/Category/SubCategoryList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSubCategoryList
         * @request GET:/api/Category/GetSubCategory
         */
        categoryGetSubCategoryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryModel, any>({
                path: `/api/Category/GetSubCategory`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySubCategoriesBySubcategoryIdList
         * @request GET:/api/Category/SubCategoriesBySubcategoryId
         */
        categorySubCategoriesBySubcategoryIdList: (
            query?: {
                /**
                 * @format int32
                 * @default 0
                 */
                subCategoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryModel[], any>({
                path: `/api/Category/SubCategoriesBySubcategoryId`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySubCategoryGroupListList
         * @request GET:/api/Category/SubCategoryGroupList
         */
        categorySubCategoryGroupListList: (
            query?: {
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryGroupModel[], any>({
                path: `/api/Category/SubCategoryGroupList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetClientCategoriesList
         * @request GET:/api/Category/GetClientCategories
         */
        categoryGetClientCategoriesList: (params: RequestParams = {}) =>
            this.request<ClientCategoryModel[], any>({
                path: `/api/Category/GetClientCategories`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetClientCategoryList
         * @request GET:/api/Category/GetClientCategory
         */
        categoryGetClientCategoryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ClientCategoryModel, any>({
                path: `/api/Category/GetClientCategory`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSortedSubCategoryList
         * @request GET:/api/Category/GetSortedSubCategory
         */
        categoryGetSortedSubCategoryList: (
            query?: {
                /** @format int32 */
                filter?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryModel[], any>({
                path: `/api/Category/GetSortedSubCategory`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSortedSubCategoryGroupList
         * @request GET:/api/Category/GetSortedSubCategoryGroup
         */
        categoryGetSortedSubCategoryGroupList: (params: RequestParams = {}) =>
            this.request<SubCategoryGroupModel[], any>({
                path: `/api/Category/GetSortedSubCategoryGroup`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSubCategoryGroupList
         * @request GET:/api/Category/GetSubCategoryGroup
         */
        categoryGetSubCategoryGroupList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryGroupModel, any>({
                path: `/api/Category/GetSubCategoryGroup`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSubCategoryGroupsBySubCategoryGroupIdList
         * @request GET:/api/Category/GetSubCategoryGroupsBySubCategoryGroupId
         */
        categoryGetSubCategoryGroupsBySubCategoryGroupIdList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryGroupModel[], any>({
                path: `/api/Category/GetSubCategoryGroupsBySubCategoryGroupId`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetSubCategoryGroupsByCategoryIdList
         * @request GET:/api/Category/GetSubCategoryGroupsByCategoryId
         */
        categoryGetSubCategoryGroupsByCategoryIdList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryGroupModel[], any>({
                path: `/api/Category/GetSubCategoryGroupsByCategoryId`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategoryGetEntryCategoryList
         * @request GET:/api/Category/GetEntryCategory
         */
        categoryGetEntryCategoryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntryCategoryModel, any>({
                path: `/api/Category/GetEntryCategory`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySaveSubCategoryGroupCreate
         * @request POST:/api/Category/SaveSubCategoryGroup
         */
        categorySaveSubCategoryGroupCreate: (data: SubCategoryGroupPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Category/SaveSubCategoryGroup`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySaveSubCategoryCreate
         * @request POST:/api/Category/SaveSubCategory
         */
        categorySaveSubCategoryCreate: (data: SubCategoryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Category/SaveSubCategory`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySaveEntryCategoryCreate
         * @request POST:/api/Category/SaveEntryCategory
         */
        categorySaveEntryCategoryCreate: (data: EntryCategoryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Category/SaveEntryCategory`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Category
         * @name CategorySaveClientCategoryCreate
         * @request POST:/api/Category/SaveClientCategory
         */
        categorySaveClientCategoryCreate: (data: ClientCategoryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Category/SaveClientCategory`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    client = {
        /**
         * No description
         *
         * @tags Client
         * @name ClientGetClientListList
         * @request GET:/api/Client/GetClientList
         */
        clientGetClientListList: (
            query?: {
                activeState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<ClientListModel[], any>({
                path: `/api/Client/GetClientList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientGetClientList
         * @request GET:/api/Client/GetClient
         */
        clientGetClientList: (
            query?: {
                /** @format int32 */
                clientId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ClientModel, any>({
                path: `/api/Client/GetClient`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientGetClientGridList
         * @request GET:/api/Client/GetClientGrid
         */
        clientGetClientGridList: (
            query?: {
                stateCode?: string;
                searchText?: string;
                activeState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<ClientModel[], any>({
                path: `/api/Client/GetClientGrid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientGetClientStatesList
         * @request GET:/api/Client/GetClientStates
         */
        clientGetClientStatesList: (params: RequestParams = {}) =>
            this.request<StateCodeModel[], any>({
                path: `/api/Client/GetClientStates`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientGetStateCodeList
         * @request GET:/api/Client/GetStateCode
         */
        clientGetStateCodeList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<StateCodeModel, any>({
                path: `/api/Client/GetStateCode`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientSaveCreate
         * @request POST:/api/Client/Save
         */
        clientSaveCreate: (data: ClientPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Client/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientUpdateClientActivationCreate
         * @request POST:/api/Client/UpdateClientActivation
         */
        clientUpdateClientActivationCreate: (data: UpdateClientActivationPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Client/UpdateClientActivation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Client
         * @name ClientSaveStateCodeCreate
         * @request POST:/api/Client/SaveStateCode
         */
        clientSaveStateCodeCreate: (data: StateCodePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Client/SaveStateCode`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    token = {
        /**
         * No description
         *
         * @tags Connect
         * @name TokenCreate
         * @request POST:/Connect/Token
         */
        tokenCreate: (
            data: {
                Username: string;
                Password: string;
                Scope: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<string, any>({
                path: `/Connect/Token`,
                method: "POST",
                body: data,
                type: ContentType.FormData,
                format: "json",
                ...params,
            }),
    };
    entries = {
        /**
         * No description
         *
         * @tags Entries
         * @name EntriesEntryNextIdDetail
         * @request GET:/api/Entries/Entry/{entryId}/NextId
         */
        entriesEntryNextIdDetail: (entryId: string, params: RequestParams = {}) =>
            this.request<string, any>({
                path: `/api/Entries/Entry/${entryId}/NextId`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesEntryPreviousIdDetail
         * @request GET:/api/Entries/Entry/{id}/PreviousId
         */
        entriesEntryPreviousIdDetail: (id: string, params: RequestParams = {}) =>
            this.request<string, any>({
                path: `/api/Entries/Entry/${id}/PreviousId`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesEntryDetail
         * @request GET:/api/Entries/Entry/{id}
         */
        entriesEntryDetail: (id: string, params: RequestParams = {}) =>
            this.request<EntryModel, any>({
                path: `/api/Entries/Entry/${id}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesSearchList
         * @request GET:/api/Entries/Search
         */
        entriesSearchList: (
            query?: {
                /** @format int32 */
                catId?: number;
                from?: string;
                to?: string;
                staffId?: string;
                /** @format int32 */
                phaseId?: number;
                assignmentId?: string;
                activeAssignmentsOnly?: ActiveEnums;
                isBillable?: ActiveEnums;
                isPosted?: ActiveEnums;
                /** @format int32 */
                locationId?: number;
                InvoiceVisible?: ActiveEnums;
                Reimbursable?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntryModel[], any>({
                path: `/api/Entries/Search`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesNeedingReceiptList
         * @request GET:/api/Entries/NeedingReceipt
         */
        entriesNeedingReceiptList: (
            query?: {
                /** @format int32 */
                catId?: number;
                from?: string;
                to?: string;
                staffId?: string;
                /** @format int32 */
                phaseId?: number;
                assignmentId?: string;
                activeAssignmentsOnly?: ActiveEnums;
                isBillable?: ActiveEnums;
                isPosted?: ActiveEnums;
                /** @format int32 */
                locationId?: number;
                InvoiceVisible?: ActiveEnums;
                Reimbursable?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntryModel[], any>({
                path: `/api/Entries/NeedingReceipt`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesSearchTotalsList
         * @request GET:/api/Entries/Search/Totals
         */
        entriesSearchTotalsList: (
            query?: {
                /** @format int32 */
                catId?: number;
                from?: string;
                to?: string;
                staffId?: string;
                /** @format int32 */
                phaseId?: number;
                assignmentId?: string;
                activeAssignmentsOnly?: ActiveEnums;
                isBillable?: ActiveEnums;
                isPosted?: ActiveEnums;
                /** @format int32 */
                locationId?: number;
                InvoiceVisible?: ActiveEnums;
                Reimbursable?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntriesTotalModel, any>({
                path: `/api/Entries/Search/Totals`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesEntryPostingCreate
         * @request POST:/api/Entries/EntryPosting
         */
        entriesEntryPostingCreate: (data: PostingEntriesPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Entries/EntryPosting`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesDeleteEntryCreate
         * @request POST:/api/Entries/DeleteEntry
         */
        entriesDeleteEntryCreate: (data: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Entries/DeleteEntry`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Entries
         * @name EntriesInsertUpdateCreate
         * @request POST:/api/Entries/InsertUpdate
         */
        entriesInsertUpdateCreate: (data: EntryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Entries/InsertUpdate`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags EntriesReceipts
         * @name EntriesReceiptDetail
         * @request GET:/api/entries/{entryId}/Receipt
         */
        entriesReceiptDetail: (entryId: string, params: RequestParams = {}) =>
            this.request<string, any>({
                path: `/api/entries/${entryId}/Receipt`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags EntriesReceipts
         * @name EntriesReceiptCreate
         * @request POST:/api/entries/{entryId}/Receipt
         */
        entriesReceiptCreate: (
            entryId: string,
            data: {
                /** @format binary */
                file?: File;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/entries/${entryId}/Receipt`,
                method: "POST",
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags EntriesReceipts
         * @name EntriesReceiptDelete
         * @request DELETE:/api/entries/{entryId}/Receipt
         */
        entriesReceiptDelete: (entryId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/entries/${entryId}/Receipt`,
                method: "DELETE",
                ...params,
            }),
    };
    expenseDetail = {
        /**
         * No description
         *
         * @tags ExpenseDetail
         * @name ExpenseDetailGetExpenseDetailList
         * @request GET:/api/ExpenseDetail/GetExpenseDetail
         */
        expenseDetailGetExpenseDetailList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                subCategoryId?: number;
                /** @format date-time */
                assignmentDt?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<ExpenseDetailsModel, any>({
                path: `/api/ExpenseDetail/GetExpenseDetail`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags ExpenseDetail
         * @name ExpenseDetailCostRateList
         * @request GET:/api/ExpenseDetail/CostRate
         */
        expenseDetailCostRateList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                subCategoryId?: number;
                /** @format date-time */
                assignmentDt?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<CostRateModel, any>({
                path: `/api/ExpenseDetail/CostRate`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),
    };
    invoicingManagement = {
        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementDetail
         * @request GET:/api/InvoicingManagement/{invoiceId}
         */
        invoicingManagementDetail: (invoiceId: number, params: RequestParams = {}) =>
            this.request<InvoiceModel, any>({
                path: `/api/InvoicingManagement/${invoiceId}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementDelete
         * @request DELETE:/api/InvoicingManagement/{invoiceId}
         */
        invoicingManagementDelete: (invoiceId: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/${invoiceId}`,
                method: "DELETE",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementFinalizeCreate
         * @request POST:/api/InvoicingManagement/Finalize
         */
        invoicingManagementFinalizeCreate: (data: FinalizeInvoicePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/Finalize`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementUnfinalizeCreate
         * @request POST:/api/InvoicingManagement/Unfinalize
         */
        invoicingManagementUnfinalizeCreate: (data: FinalizeInvoicePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/Unfinalize`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementInsertInvoiceCreate
         * @request POST:/api/InvoicingManagement/InsertInvoice
         */
        invoicingManagementInsertInvoiceCreate: (data: InsertInvoicePostModel, params: RequestParams = {}) =>
            this.request<number, any>({
                path: `/api/InvoicingManagement/InsertInvoice`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementUpdateInvoiceCreate
         * @request POST:/api/InvoicingManagement/UpdateInvoice
         */
        invoicingManagementUpdateInvoiceCreate: (data: UpdateInvoicePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/UpdateInvoice`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementSearchList
         * @request GET:/api/InvoicingManagement/Search
         */
        invoicingManagementSearchList: (
            query?: {
                from?: string;
                to?: string;
                /** @format int32 */
                assignmentId?: number;
                finalizeOnly?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<InvoiceModel[], any>({
                path: `/api/InvoicingManagement/Search`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementIncludedEntriesList
         * @request GET:/api/InvoicingManagement/IncludedEntries
         */
        invoicingManagementIncludedEntriesList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntryModel[], any>({
                path: `/api/InvoicingManagement/IncludedEntries`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementIncludedEntriesTotalsList
         * @request GET:/api/InvoicingManagement/IncludedEntries/Totals
         */
        invoicingManagementIncludedEntriesTotalsList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntriesTotalModel, any>({
                path: `/api/InvoicingManagement/IncludedEntries/Totals`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementPotentialEntriesList
         * @request GET:/api/InvoicingManagement/PotentialEntries
         */
        invoicingManagementPotentialEntriesList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntryModel[], any>({
                path: `/api/InvoicingManagement/PotentialEntries`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementPotentialEntriesTotalsList
         * @request GET:/api/InvoicingManagement/PotentialEntries/Totals
         */
        invoicingManagementPotentialEntriesTotalsList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<EntriesTotalModel, any>({
                path: `/api/InvoicingManagement/PotentialEntries/Totals`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementIncludedItemDelete
         * @request DELETE:/api/InvoicingManagement/IncludedItem/{entryId}
         */
        invoicingManagementIncludedItemDelete: (entryId: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/IncludedItem/${entryId}`,
                method: "DELETE",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementIncludedItemsCreate
         * @request POST:/api/InvoicingManagement/IncludedItems
         */
        invoicingManagementIncludedItemsCreate: (data: InsertPotentialEntryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/IncludedItems`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementOutstandingChargesGridList
         * @request GET:/api/InvoicingManagement/OutstandingChargesGrid
         */
        invoicingManagementOutstandingChargesGridList: (
            query?: {
                endDt?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<OutstandingChargesModel[], any>({
                path: `/api/InvoicingManagement/OutstandingChargesGrid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementInvoiceAdjustmentsGridList
         * @request GET:/api/InvoicingManagement/InvoiceAdjustmentsGrid
         */
        invoicingManagementInvoiceAdjustmentsGridList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<InvoiceAdjustmentModel[], any>({
                path: `/api/InvoicingManagement/InvoiceAdjustmentsGrid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementInvoiceAdjustmentsGridTotalsList
         * @request GET:/api/InvoicingManagement/InvoiceAdjustmentsGrid/Totals
         */
        invoicingManagementInvoiceAdjustmentsGridTotalsList: (
            query?: {
                /** @format int32 */
                invoiceId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AdjustmentsTotalModel, any>({
                path: `/api/InvoicingManagement/InvoiceAdjustmentsGrid/Totals`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementAdjustmentItemDelete
         * @request DELETE:/api/InvoicingManagement/AdjustmentItem/{id}
         */
        invoicingManagementAdjustmentItemDelete: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/AdjustmentItem/${id}`,
                method: "DELETE",
                ...params,
            }),

        /**
         * No description
         *
         * @tags InvoicingManagement
         * @name InvoicingManagementAdjustmentItemCreate
         * @request POST:/api/InvoicingManagement/AdjustmentItem
         */
        invoicingManagementAdjustmentItemCreate: (data: InsertAdjustmentPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/InvoicingManagement/AdjustmentItem`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    lookupList = {
        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListStateCodesListList
         * @request GET:/api/LookupList/StateCodesList
         */
        lookupListStateCodesListList: (params: RequestParams = {}) =>
            this.request<StateCodeModel[], any>({
                path: `/api/LookupList/StateCodesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetMembershipRolesListList
         * @request GET:/api/LookupList/GetMembershipRolesList
         */
        lookupListGetMembershipRolesListList: (params: RequestParams = {}) =>
            this.request<MembershipRoleModel[], any>({
                path: `/api/LookupList/GetMembershipRolesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetSetupCategoriesList
         * @request GET:/api/LookupList/GetSetupCategories
         */
        lookupListGetSetupCategoriesList: (params: RequestParams = {}) =>
            this.request<SetupCategoryModel[], any>({
                path: `/api/LookupList/GetSetupCategories`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetSetupDetailsList
         * @request GET:/api/LookupList/GetSetupDetails
         */
        lookupListGetSetupDetailsList: (
            query?: {
                /** @format int32 */
                categoryId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SetupDetailModel[], any>({
                path: `/api/LookupList/GetSetupDetails`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetSetupDetailByIdList
         * @request GET:/api/LookupList/GetSetupDetailById
         */
        lookupListGetSetupDetailByIdList: (
            query?: {
                /** @format int32 */
                setupDetailId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SetupDetailModel, any>({
                path: `/api/LookupList/GetSetupDetailById`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetProjectRolesListList
         * @request GET:/api/LookupList/GetProjectRolesList
         */
        lookupListGetProjectRolesListList: (params: RequestParams = {}) =>
            this.request<ProjectRoleModel[], any>({
                path: `/api/LookupList/GetProjectRolesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetUtilizationCodesListList
         * @request GET:/api/LookupList/GetUtilizationCodesList
         */
        lookupListGetUtilizationCodesListList: (params: RequestParams = {}) =>
            this.request<UtilizationCodeModel[], any>({
                path: `/api/LookupList/GetUtilizationCodesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetInvoiceTypesListList
         * @request GET:/api/LookupList/GetInvoiceTypesList
         */
        lookupListGetInvoiceTypesListList: (params: RequestParams = {}) =>
            this.request<InvoiceTypeModel[], any>({
                path: `/api/LookupList/GetInvoiceTypesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetInvoiceStylesListList
         * @request GET:/api/LookupList/GetInvoiceStylesList
         */
        lookupListGetInvoiceStylesListList: (params: RequestParams = {}) =>
            this.request<InvoiceStyleModel[], any>({
                path: `/api/LookupList/GetInvoiceStylesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetTaskCodesListList
         * @request GET:/api/LookupList/GetTaskCodesList
         */
        lookupListGetTaskCodesListList: (params: RequestParams = {}) =>
            this.request<TaskCodeModel[], any>({
                path: `/api/LookupList/GetTaskCodesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetBillingTermsListList
         * @request GET:/api/LookupList/GetBillingTermsList
         */
        lookupListGetBillingTermsListList: (params: RequestParams = {}) =>
            this.request<BillingTermModel[], any>({
                path: `/api/LookupList/GetBillingTermsList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetExtensionsListList
         * @request GET:/api/LookupList/GetExtensionsList
         */
        lookupListGetExtensionsListList: (params: RequestParams = {}) =>
            this.request<ExtensionModel[], any>({
                path: `/api/LookupList/GetExtensionsList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetAccountingCategoriesListList
         * @request GET:/api/LookupList/GetAccountingCategoriesList
         */
        lookupListGetAccountingCategoriesListList: (params: RequestParams = {}) =>
            this.request<AccountingCategoryModel[], any>({
                path: `/api/LookupList/GetAccountingCategoriesList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags LookupList
         * @name LookupListGetAccountingCodesListList
         * @request GET:/api/LookupList/GetAccountingCodesList
         */
        lookupListGetAccountingCodesListList: (params: RequestParams = {}) =>
            this.request<AccountingCodeModel[], any>({
                path: `/api/LookupList/GetAccountingCodesList`,
                method: "GET",
                format: "json",
                ...params,
            }),
    };
    powerBiReports = {
        /**
         * No description
         *
         * @tags PowerBIReports
         * @name PowerBiReportsReportsListList
         * @request GET:/api/PowerBIReports/ReportsList
         */
        powerBiReportsReportsListList: (params: RequestParams = {}) =>
            this.request<ReportUiModel[], any>({
                path: `/api/PowerBIReports/ReportsList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags PowerBIReports
         * @name PowerBiReportsGenerateProjectManagementPmJustPostedChargesReportList
         * @request GET:/api/PowerBIReports/GenerateProjectManagementPmJustPostedChargesReport
         */
        powerBiReportsGenerateProjectManagementPmJustPostedChargesReportList: (
            data?: {
                /** @format int32 */
                amountTypeId?: number;
                entryIds?: Array<string>;
            },
            params: RequestParams = {},
        ) =>
            this.request<PowerBIReportAccessModel, any>({
                path: `api/PowerBIReports/GenerateProjectManagementPmJustPostedChargesReport`,
                method: "POST",
                body: data,
                format: "json",
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags PowerBIReports
         * @name PowerBiReportsGenerateReportDetail
         * @request GET:/api/PowerBIReports/GenerateReport/{reportId}
         */
        powerBiReportsGenerateReportDetail: (
            reportId: number,
            query?: {
                /** @format date-time */
                fromDt?: string;
                /** @format date-time */
                toDt?: string;
                staffId?: number[];
                /** @format int32 */
                staffTypeId?: number;
                /** @format int32 */
                sortingId?: number;
                /** @format int32 */
                amountTypeId?: number;
                /** @format int32 */
                utilCodeId?: number;
                /** @format int32 */
                assignmentId?: number;
                postedId?: ActiveEnums;
                activeId?: ActiveEnums;
                billableAssignmentId?: ActiveEnums;
                billableId?: ActiveEnums;
                /** @format int32 */
                invoiceId?: number;
                invoiced?: ActiveEnums;
                invoiceVisibleId?: ActiveEnums;
                /** @format int32 */
                logo?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<PowerBIReportAccessModel, any>({
                path: `/api/PowerBIReports/GenerateReport/${reportId}`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),
    };
    powerBiSettings = {
        /**
         * No description
         *
         * @tags PowerBISettings
         * @name PowerBiSettingsList
         * @request GET:/api/PowerBISettings
         */
        powerBiSettingsList: (params: RequestParams = {}) =>
            this.request<PowerBISettingModel, any>({
                path: `/api/PowerBISettings`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags PowerBISettings
         * @name PowerBiSettingsTenantUpdate
         * @request PUT:/api/PowerBISettings/{id}/tenant
         */
        powerBiSettingsTenantUpdate: (
            id: number,
            data: UpdatePowerBITenantSettingPutModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/PowerBISettings/${id}/tenant`,
                method: "PUT",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags PowerBISettings
         * @name PowerBiSettingsSecretUpdate
         * @request PUT:/api/PowerBISettings/{id}/secret
         */
        powerBiSettingsSecretUpdate: (
            id: number,
            data: UpdatePowerBISecretSettingPutModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/PowerBISettings/${id}/secret`,
                method: "PUT",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    resetPassword = {
        /**
         * No description
         *
         * @tags ResetPassword
         * @name ResetPasswordRequestCreate
         * @request POST:/user/ResetPassword/Request
         */
        resetPasswordRequestCreate: (data: RequestResetPasswordPost, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/user/ResetPassword/Request`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags ResetPassword
         * @name ResetPasswordCreate
         * @request POST:/user/ResetPassword
         */
        resetPasswordCreate: (data: ResetPasswordPost, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/user/ResetPassword`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    roster = {
        /**
         * No description
         *
         * @tags Roster
         * @name RosterProjectRoleIdList
         * @request GET:/api/Roster/ProjectRoleId
         */
        rosterProjectRoleIdList: (
            query?: {
                /** @format int32 */
                AssignmentId?: number;
                /** @format int32 */
                StaffId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<number, any>({
                path: `/api/Roster/ProjectRoleId`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterSaveRosterDetailCreate
         * @request POST:/api/Roster/SaveRosterDetail
         */
        rosterSaveRosterDetailCreate: (data: AddEditRosterDetailPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Roster/SaveRosterDetail`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterUpdateRosterStaffProjectRoleCreate
         * @request POST:/api/Roster/UpdateRosterStaffProjectRole
         */
        rosterUpdateRosterStaffProjectRoleCreate: (
            data: UpdateRosterStaffProjectRolePostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Roster/UpdateRosterStaffProjectRole`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterUpdateRosterStaffActivationCreate
         * @request POST:/api/Roster/UpdateRosterStaffActivation
         */
        rosterUpdateRosterStaffActivationCreate: (
            data: UpdateRosterStaffActivationPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Roster/UpdateRosterStaffActivation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterUpdateRosterStaffSortByCreate
         * @request POST:/api/Roster/UpdateRosterStaffSortBy
         */
        rosterUpdateRosterStaffSortByCreate: (data: UpdateRosterStaffSortByPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Roster/UpdateRosterStaffSortBy`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterInsertRosterStaffCreate
         * @request POST:/api/Roster/InsertRosterStaff
         */
        rosterInsertRosterStaffCreate: (data: InsertAssignmentRosterStaffPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Roster/InsertRosterStaff`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags Roster
         * @name RosterDeleteRosterDetailDelete
         * @request DELETE:/api/Roster/DeleteRosterDetail
         */
        rosterDeleteRosterDetailDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Roster/DeleteRosterDetail`,
                method: "DELETE",
                query: query,
                ...params,
            }),
    };
    setupApi = {
        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedStaffCompanyList
         * @request GET:/api/SetupApi/GetSortedStaffCompany
         */
        setupApiGetSortedStaffCompanyList: (params: RequestParams = {}) =>
            this.request<StaffCompanyModel[], any>({
                path: `/api/SetupApi/GetSortedStaffCompany`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetStaffCompanyList
         * @request GET:/api/SetupApi/GetStaffCompany
         */
        setupApiGetStaffCompanyList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffCompanyModel, any>({
                path: `/api/SetupApi/GetStaffCompany`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedFullTimeEmployeeList
         * @request GET:/api/SetupApi/GetSortedFullTimeEmployee
         */
        setupApiGetSortedFullTimeEmployeeList: (params: RequestParams = {}) =>
            this.request<FullTimeEmployeeModel[], any>({
                path: `/api/SetupApi/GetSortedFullTimeEmployee`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetFullTimeEmployeeList
         * @request GET:/api/SetupApi/GetFullTimeEmployee
         */
        setupApiGetFullTimeEmployeeList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<FullTimeEmployeeModel, any>({
                path: `/api/SetupApi/GetFullTimeEmployee`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedBillingTermList
         * @request GET:/api/SetupApi/GetSortedBillingTerm
         */
        setupApiGetSortedBillingTermList: (params: RequestParams = {}) =>
            this.request<BillingTermModel[], any>({
                path: `/api/SetupApi/GetSortedBillingTerm`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetBillingTermList
         * @request GET:/api/SetupApi/GetBillingTerm
         */
        setupApiGetBillingTermList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<BillingTermModel, any>({
                path: `/api/SetupApi/GetBillingTerm`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedExtensionList
         * @request GET:/api/SetupApi/GetSortedExtension
         */
        setupApiGetSortedExtensionList: (params: RequestParams = {}) =>
            this.request<ExtensionModel[], any>({
                path: `/api/SetupApi/GetSortedExtension`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedSubCategoryDefaultRateList
         * @request GET:/api/SetupApi/GetSortedSubCategoryDefaultRate
         */
        setupApiGetSortedSubCategoryDefaultRateList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryDefaultRateModel[], any>({
                path: `/api/SetupApi/GetSortedSubCategoryDefaultRate`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedSubCategoryAccountingDetailList
         * @request GET:/api/SetupApi/GetSortedSubCategoryAccountingDetail
         */
        setupApiGetSortedSubCategoryAccountingDetailList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryAccountingDetailModel[], any>({
                path: `/api/SetupApi/GetSortedSubCategoryAccountingDetail`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSubCategoryDefaultRateList
         * @request GET:/api/SetupApi/GetSubCategoryDefaultRate
         */
        setupApiGetSubCategoryDefaultRateList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryDefaultRateModel, any>({
                path: `/api/SetupApi/GetSubCategoryDefaultRate`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSubCategoryAccountingDetailList
         * @request GET:/api/SetupApi/GetSubCategoryAccountingDetail
         */
        setupApiGetSubCategoryAccountingDetailList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<SubCategoryAccountingDetailModel, any>({
                path: `/api/SetupApi/GetSubCategoryAccountingDetail`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetExtensionList
         * @request GET:/api/SetupApi/GetExtension
         */
        setupApiGetExtensionList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ExtensionModel, any>({
                path: `/api/SetupApi/GetExtension`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedInvoiceStyleList
         * @request GET:/api/SetupApi/GetSortedInvoiceStyle
         */
        setupApiGetSortedInvoiceStyleList: (params: RequestParams = {}) =>
            this.request<InvoiceStyleModel[], any>({
                path: `/api/SetupApi/GetSortedInvoiceStyle`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetInvoiceStyleList
         * @request GET:/api/SetupApi/GetInvoiceStyle
         */
        setupApiGetInvoiceStyleList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<InvoiceStyleModel, any>({
                path: `/api/SetupApi/GetInvoiceStyle`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedInvoiceTypeList
         * @request GET:/api/SetupApi/GetSortedInvoiceType
         */
        setupApiGetSortedInvoiceTypeList: (params: RequestParams = {}) =>
            this.request<InvoiceTypeModel[], any>({
                path: `/api/SetupApi/GetSortedInvoiceType`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetInvoiceTypeList
         * @request GET:/api/SetupApi/GetInvoiceType
         */
        setupApiGetInvoiceTypeList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<InvoiceTypeModel, any>({
                path: `/api/SetupApi/GetInvoiceType`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedProjectRoleList
         * @request GET:/api/SetupApi/GetSortedProjectRole
         */
        setupApiGetSortedProjectRoleList: (params: RequestParams = {}) =>
            this.request<ProjectRoleModel[], any>({
                path: `/api/SetupApi/GetSortedProjectRole`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetProjectRoleList
         * @request GET:/api/SetupApi/GetProjectRole
         */
        setupApiGetProjectRoleList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ProjectRoleModel, any>({
                path: `/api/SetupApi/GetProjectRole`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedUtilizationCodeList
         * @request GET:/api/SetupApi/GetSortedUtilizationCode
         */
        setupApiGetSortedUtilizationCodeList: (params: RequestParams = {}) =>
            this.request<UtilizationCodeModel[], any>({
                path: `/api/SetupApi/GetSortedUtilizationCode`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetUtilizationCodeList
         * @request GET:/api/SetupApi/GetUtilizationCode
         */
        setupApiGetUtilizationCodeList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<UtilizationCodeModel, any>({
                path: `/api/SetupApi/GetUtilizationCode`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedEntryCategoryList
         * @request GET:/api/SetupApi/GetSortedEntryCategory
         */
        setupApiGetSortedEntryCategoryList: (params: RequestParams = {}) =>
            this.request<EntryCategoryModel[], any>({
                path: `/api/SetupApi/GetSortedEntryCategory`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedAccountingCategoryList
         * @request GET:/api/SetupApi/GetSortedAccountingCategory
         */
        setupApiGetSortedAccountingCategoryList: (params: RequestParams = {}) =>
            this.request<AccountingCategoryModel[], any>({
                path: `/api/SetupApi/GetSortedAccountingCategory`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetAccountingCategoryList
         * @request GET:/api/SetupApi/GetAccountingCategory
         */
        setupApiGetAccountingCategoryList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AccountingCategoryModel, any>({
                path: `/api/SetupApi/GetAccountingCategory`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedAccountingCodeList
         * @request GET:/api/SetupApi/GetSortedAccountingCode
         */
        setupApiGetSortedAccountingCodeList: (params: RequestParams = {}) =>
            this.request<AccountingCodeModel[], any>({
                path: `/api/SetupApi/GetSortedAccountingCode`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetAccountingCodeList
         * @request GET:/api/SetupApi/GetAccountingCode
         */
        setupApiGetAccountingCodeList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<AccountingCodeModel, any>({
                path: `/api/SetupApi/GetAccountingCode`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedReimbursableExpenseExceptionList
         * @request GET:/api/SetupApi/GetSortedReimbursableExpenseException
         */
        setupApiGetSortedReimbursableExpenseExceptionList: (params: RequestParams = {}) =>
            this.request<ReimbursableExpenseExceptionModel[], any>({
                path: `/api/SetupApi/GetSortedReimbursableExpenseException`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetReimbursableExpenseExceptionList
         * @request GET:/api/SetupApi/GetReimbursableExpenseException
         */
        setupApiGetReimbursableExpenseExceptionList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<ReimbursableExpenseExceptionModel, any>({
                path: `/api/SetupApi/GetReimbursableExpenseException`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedStateCodeList
         * @request GET:/api/SetupApi/GetSortedStateCode
         */
        setupApiGetSortedStateCodeList: (params: RequestParams = {}) =>
            this.request<StateCodeModel[], any>({
                path: `/api/SetupApi/GetSortedStateCode`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedClientCategoryList
         * @request GET:/api/SetupApi/GetSortedClientCategory
         */
        setupApiGetSortedClientCategoryList: (params: RequestParams = {}) =>
            this.request<ClientCategoryModel[], any>({
                path: `/api/SetupApi/GetSortedClientCategory`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSortedCityStateList
         * @request GET:/api/SetupApi/GetSortedCityState
         */
        setupApiGetSortedCityStateList: (params: RequestParams = {}) =>
            this.request<CityStateModel[], any>({
                path: `/api/SetupApi/GetSortedCityState`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetCityStateList
         * @request GET:/api/SetupApi/GetCityState
         */
        setupApiGetCityStateList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<CityStateModel, any>({
                path: `/api/SetupApi/GetCityState`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiGetSystemInfoList
         * @request GET:/api/SetupApi/GetSystemInfo
         */
        setupApiGetSystemInfoList: (params: RequestParams = {}) =>
            this.request<SystemInfoModel[], any>({
                path: `/api/SetupApi/GetSystemInfo`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiMoveUpDownSortByRecordCreate
         * @request POST:/api/SetupApi/MoveUpDownSortByRecord
         */
        setupApiMoveUpDownSortByRecordCreate: (data: MoveUpDownSortByRecordPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/MoveUpDownSortByRecord`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiDeleteSelectedRecordDelete
         * @request DELETE:/api/SetupApi/DeleteSelectedRecord
         */
        setupApiDeleteSelectedRecordDelete: (
            query?: {
                tblName?: string;
                primeKeyName?: string;
                id?: string;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/SetupApi/DeleteSelectedRecord`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveSystemInfoCreate
         * @request POST:/api/SetupApi/SaveSystemInfo
         */
        setupApiSaveSystemInfoCreate: (data: SystemInfoPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveSystemInfo`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveBillingTermCreate
         * @request POST:/api/SetupApi/SaveBillingTerm
         */
        setupApiSaveBillingTermCreate: (data: BillingTermPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveBillingTerm`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveExtensionCreate
         * @request POST:/api/SetupApi/SaveExtension
         */
        setupApiSaveExtensionCreate: (data: ExtensionPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveExtension`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveInvoiceStyleCreate
         * @request POST:/api/SetupApi/SaveInvoiceStyle
         */
        setupApiSaveInvoiceStyleCreate: (data: InvoiceStylePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveInvoiceStyle`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveInvoiceTypeCreate
         * @request POST:/api/SetupApi/SaveInvoiceType
         */
        setupApiSaveInvoiceTypeCreate: (data: InvoiceTypePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveInvoiceType`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveProjectRoleCreate
         * @request POST:/api/SetupApi/SaveProjectRole
         */
        setupApiSaveProjectRoleCreate: (data: ProjectRolePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveProjectRole`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveAccountingCategoryCreate
         * @request POST:/api/SetupApi/SaveAccountingCategory
         */
        setupApiSaveAccountingCategoryCreate: (data: AccountingCategoryPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveAccountingCategory`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveAccountingCodeCreate
         * @request POST:/api/SetupApi/SaveAccountingCode
         */
        setupApiSaveAccountingCodeCreate: (data: AccountingCodePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveAccountingCode`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveReimbursableExpenseExceptionCreate
         * @request POST:/api/SetupApi/SaveReimbursableExpenseException
         */
        setupApiSaveReimbursableExpenseExceptionCreate: (
            data: ReimbursableExpenseExceptionPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveReimbursableExpenseException`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveFullTimeEmployeeCreate
         * @request POST:/api/SetupApi/SaveFullTimeEmployee
         */
        setupApiSaveFullTimeEmployeeCreate: (data: FullTimeEmployeePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveFullTimeEmployee`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveCityStateCreate
         * @request POST:/api/SetupApi/SaveCityState
         */
        setupApiSaveCityStateCreate: (data: CityStatePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveCityState`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveUtilizationCodeCreate
         * @request POST:/api/SetupApi/SaveUtilizationCode
         */
        setupApiSaveUtilizationCodeCreate: (data: UtilizationCodePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveUtilizationCode`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveSubCategoryDefaultRateCreate
         * @request POST:/api/SetupApi/SaveSubCategoryDefaultRate
         */
        setupApiSaveSubCategoryDefaultRateCreate: (data: SubCategoryDefaultRatePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveSubCategoryDefaultRate`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags SetupApi
         * @name SetupApiSaveSubCategoryAccountingDetailCreate
         * @request POST:/api/SetupApi/SaveSubCategoryAccountingDetail
         */
        setupApiSaveSubCategoryAccountingDetailCreate: (
            data: SubCategoryAccountingDetailPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/SetupApi/SaveSubCategoryAccountingDetail`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    staff = {
        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffingListDetail
         * @request GET:/api/Staff/GetStaffingList/{id}
         */
        staffGetStaffingListDetail: (id: number, params: RequestParams = {}) =>
            this.request<StaffingModel[], any>({
                path: `/api/Staff/GetStaffingList/${id}`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffingListList
         * @request GET:/api/Staff/GetStaffingList
         */
        staffGetStaffingListList: (
            query?: {
                activeState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffingModel[], any>({
                path: `/api/Staff/GetStaffingList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffList
         * @request GET:/api/Staff/GetStaff
         */
        staffGetStaffList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffingModel, any>({
                path: `/api/Staff/GetStaff`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffRatesList
         * @request GET:/api/Staff/GetStaffRates
         */
        staffGetStaffRatesList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffingDetailsModel[], any>({
                path: `/api/Staff/GetStaffRates`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetPerformanceListList
         * @request GET:/api/Staff/GetPerformanceList
         */
        staffGetPerformanceListList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<PerformanceModel[], any>({
                path: `/api/Staff/GetPerformanceList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffGridList
         * @request GET:/api/Staff/GetStaffGrid
         */
        staffGetStaffGridList: (
            query?: {
                roleId?: string;
                activeState?: ActiveEnums;
                hourlyState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffingModel[], any>({
                path: `/api/Staff/GetStaffGrid`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffProfileListList
         * @request GET:/api/Staff/GetStaffProfileList
         */
        staffGetStaffProfileListList: (
            query?: {
                /** @format int32 */
                id?: number;
                /**
                 * @format int32
                 * @default 0
                 */
                utilId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffingRosterModel[], any>({
                path: `/api/Staff/GetStaffProfileList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffCompanyListList
         * @request GET:/api/Staff/GetStaffCompanyList
         */
        staffGetStaffCompanyListList: (params: RequestParams = {}) =>
            this.request<StaffCompanyModel[], any>({
                path: `/api/Staff/GetStaffCompanyList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffManagerListList
         * @request GET:/api/Staff/GetStaffManagerList
         */
        staffGetStaffManagerListList: (params: RequestParams = {}) =>
            this.request<StaffingModel[], any>({
                path: `/api/Staff/GetStaffManagerList`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetStaffAssignmentsListList
         * @request GET:/api/Staff/GetStaffAssignmentsList
         */
        staffGetStaffAssignmentsListList: (
            query?: {
                id?: string;
                showOnlyActive?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<StaffAssignmentModel[], any>({
                path: `/api/Staff/GetStaffAssignmentsList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffGetAssignmentsListList
         * @request GET:/api/Staff/GetAssignmentsList
         */
        staffGetAssignmentsListList: (
            query?: {
                /** @format int32 */
                billable?: number;
                activeState?: ActiveEnums;
            },
            params: RequestParams = {},
        ) =>
            this.request<AssignmentModel[], any>({
                path: `/api/Staff/GetAssignmentsList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffRestoreCreate
         * @request POST:/api/Staff/{id}/restore
         */
        staffRestoreCreate: (id: number, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/${id}/restore`,
                method: "POST",
                ...params,
            }),

        /**
         * No description
         *
         * @tags Staff
         * @name StaffDeleteEntryDelete
         * @request DELETE:/api/Staff/DeleteEntry
         */
        staffDeleteEntryDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Staff/DeleteEntry`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffContact
         * @name StaffContactSaveCreate
         * @request POST:/api/Staff/Contact/Save
         */
        staffContactSaveCreate: (data: StaffContactPostModel, params: RequestParams = {}) =>
            this.request<number, any>({
                path: `/api/Staff/Contact/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffNotification
         * @name StaffNotificationSaveCreate
         * @request POST:/api/Staff/Notification/Save
         */
        staffNotificationSaveCreate: (data: StaffNotificationPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/Notification/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffPerformance
         * @name StaffPerformanceSaveCreate
         * @request POST:/api/Staff/Performance/Save
         */
        staffPerformanceSaveCreate: (data: StaffPerformancePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/Performance/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffPerformance
         * @name StaffPerformanceDeleteDelete
         * @request DELETE:/api/Staff/Performance/Delete
         */
        staffPerformanceDeleteDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Staff/Performance/Delete`,
                method: "DELETE",
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffPersonal
         * @name StaffPersonalSaveCreate
         * @request POST:/api/Staff/Personal/Save
         */
        staffPersonalSaveCreate: (data: StaffPersonalPostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/Personal/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffProfile
         * @name StaffProfileUploadPictureCreate
         * @request POST:/api/Staff/Profile/{id}/upload/picture
         */
        staffProfileUploadPictureCreate: (
            id: number,
            data: {
                /** @format binary */
                file?: File;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Staff/Profile/${id}/upload/picture`,
                method: "POST",
                body: data,
                type: ContentType.FormData,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffProfile
         * @name StaffProfileSaveCreate
         * @request POST:/api/Staff/Profile/Save
         */
        staffProfileSaveCreate: (data: StaffProfilePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/Profile/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffRate
         * @name StaffRateSaveCreate
         * @request POST:/api/Staff/Rate/Save
         */
        staffRateSaveCreate: (data: StaffRatePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/Staff/Rate/Save`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags StaffRate
         * @name StaffRateDeleteDelete
         * @request DELETE:/api/Staff/Rate/Delete
         */
        staffRateDeleteDelete: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/Staff/Rate/Delete`,
                method: "DELETE",
                query: query,
                ...params,
            }),
    };
    user = {
        /**
         * No description
         *
         * @tags User
         * @name UserChangePasswordCreate
         * @request POST:/api/User/ChangePassword
         */
        userChangePasswordCreate: (data: ChangePasswordPost, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/User/ChangePassword`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UserAdminChangePasswordCreate
         * @request POST:/api/User/AdminChangePassword
         */
        userAdminChangePasswordCreate: (data: NewPasswordPost, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/User/AdminChangePassword`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UserConfirmEmailCreate
         * @request POST:/api/User/{userId}/ConfirmEmail
         */
        userConfirmEmailCreate: (userId: string, data: ConfirmEMailPost, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/User/${userId}/ConfirmEmail`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    workLocation = {
        /**
         * No description
         *
         * @tags WorkLocation
         * @name WorkLocationGetWorkLocationsListList
         * @request GET:/api/WorkLocation/GetWorkLocationsList
         */
        workLocationGetWorkLocationsListList: (
            query?: {
                ids?: string;
                activeOnly?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkLocationModel[], any>({
                path: `/api/WorkLocation/GetWorkLocationsList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkLocation
         * @name WorkLocationGetSortedWorkLocationList
         * @request GET:/api/WorkLocation/GetSortedWorkLocation
         */
        workLocationGetSortedWorkLocationList: (params: RequestParams = {}) =>
            this.request<WorkLocationModel[], any>({
                path: `/api/WorkLocation/GetSortedWorkLocation`,
                method: "GET",
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkLocation
         * @name WorkLocationGetWorkLocationList
         * @request GET:/api/WorkLocation/GetWorkLocation
         */
        workLocationGetWorkLocationList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkLocationModel, any>({
                path: `/api/WorkLocation/GetWorkLocation`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkLocation
         * @name WorkLocationCreateAssignmentWorkLocationCreate
         * @request POST:/api/WorkLocation/CreateAssignmentWorkLocation
         */
        workLocationCreateAssignmentWorkLocationCreate: (
            data: InsertWorkLocationPostModel,
            params: RequestParams = {},
        ) =>
            this.request<number, any>({
                path: `/api/WorkLocation/CreateAssignmentWorkLocation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkLocation
         * @name WorkLocationUpdateAssignmentWorkLocationActivationCreate
         * @request POST:/api/WorkLocation/UpdateAssignmentWorkLocationActivation
         */
        workLocationUpdateAssignmentWorkLocationActivationCreate: (
            data: UpdateAssignmentWorkLocationActivationPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/WorkLocation/UpdateAssignmentWorkLocationActivation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
    workPackage = {
        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageGetAssignmentPackageList
         * @request GET:/api/WorkPackage/GetAssignmentPackage
         */
        workPackageGetAssignmentPackageList: (
            query?: {
                /** @format int32 */
                id?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkPackageModel, any>({
                path: `/api/WorkPackage/GetAssignmentPackage`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageFilterWorkPackagesListList
         * @request GET:/api/WorkPackage/FilterWorkPackagesList
         */
        workPackageFilterWorkPackagesListList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
                /** @format int32 */
                phaseId?: number;
                activeOnly?: boolean;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkPackageModel[], any>({
                path: `/api/WorkPackage/FilterWorkPackagesList`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageWorkPackagesListByAssignmentList
         * @request GET:/api/WorkPackage/WorkPackagesListByAssignment
         */
        workPackageWorkPackagesListByAssignmentList: (
            query?: {
                /** @format int32 */
                assignmentId?: number;
            },
            params: RequestParams = {},
        ) =>
            this.request<WorkPackageModel[], any>({
                path: `/api/WorkPackage/WorkPackagesListByAssignment`,
                method: "GET",
                query: query,
                format: "json",
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageCreateAssignmentWorkPackageCreate
         * @request POST:/api/WorkPackage/CreateAssignmentWorkPackage
         */
        workPackageCreateAssignmentWorkPackageCreate: (data: InsertWorkPackagePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/WorkPackage/CreateAssignmentWorkPackage`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageUpdateAssignmentWorkPackageCreate
         * @request POST:/api/WorkPackage/UpdateAssignmentWorkPackage
         */
        workPackageUpdateAssignmentWorkPackageCreate: (data: UpdateWorkPackagePostModel, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/WorkPackage/UpdateAssignmentWorkPackage`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageUpdateWorkPackageActivationCreate
         * @request POST:/api/WorkPackage/UpdateWorkPackageActivation
         */
        workPackageUpdateWorkPackageActivationCreate: (
            data: UpdateWorkPackageActivationPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/WorkPackage/UpdateWorkPackageActivation`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags WorkPackage
         * @name WorkPackageUpdateWorkPackageSortByCreate
         * @request POST:/api/WorkPackage/UpdateWorkPackageSortBy
         */
        workPackageUpdateWorkPackageSortByCreate: (
            data: UpdateWorkPackageSortOrderPostModel,
            params: RequestParams = {},
        ) =>
            this.request<void, any>({
                path: `/api/WorkPackage/UpdateWorkPackageSortBy`,
                method: "POST",
                body: data,
                type: ContentType.Json,
                ...params,
            }),
    };
}
